<template lang="pug">
modal(ref="modal", :loading="loading")
    template(slot="title") Add Override

    template(slot="body")
      div(v-if="entry !== null")
        form(@submit.prevent="")
            fieldset(:disabled="onLoading('save-override-pricebook-entry')")
                p.m-t-md._500 Product Name
                    p {{ entry.name }}
                p.m-t-md._500 Barcode
                    p {{ entry.code }}
                p.m-t-md._500 Status
                    p(v-if="restrictVisibility", class="alert alert-warning")
                        | The product status override has been restricted

                    .form-group
                        p(v-if="canManageStationPrices && !restrictVisibility")
                            label.md-switch
                                input(
                                    :disabled="restrictVisibility"
                                    v-model="itemIsVisible",
                                    type="checkbox",
                                    class="has-value"
                                )
                                i.indigo
                                | Active

                        p(v-if="!itemIsVisible") The product is inactive
                        p(v-else) Product is active

                    template(v-if="entry.price_type == 1")
                        p(v-if="restrictPricing", class="alert alert-warning")
                            | The product pricing override has been restricted

                        p.m-t-md._500 Recommended Retail Price By HQ
                        p {{ entry.rrp }}

                        p.m-t-sm._500 Maximum Price Allowed
                        p {{ entry.max_unit_price }}

                        p.m-t-md._500 Pricing

                        .form-group
                            label Station Price
                            input.form-control(
                                v-if="canManageStationPrices"
                                :disabled="restrictPricing"
                                v-validate="pricingValidation",
                                v-model="entry.entry_price",
                                type="number",
                                :placeholder="entry.unit_price"
                                :key="`unit_price_${entry.id}`",
                                name="price"
                            )

                            p(v-if="!canManageStationPrices") {{ entry.entry_price }}
                            small.clear.m-t-xs(v-if="entry.pricebook_rrp") RRP {{ entry.pricebook_rrp }}
                            span.text-danger(v-if="errors.has('price')") {{ errors.first('price') }}

                        label.m-t
                            | Cost
                            small.text-muted (Average cost from inventory)

                        v-loading(loader="get-average-cost") {{ entry.latest_cost }}

                    template(v-else-if="entry.price_type == 0")
                        .row
                            .col-xs-2
                                p.m-r-sm._500 Active
                            .col-xs-4
                                p.m-r-sm._500 Variant Name
                            .col-xs-3
                                p.m-r-sm._500 Cost
                            .col-xs-3
                                p.m-r-sm._500 Price

                        .row(v-for="v in entry.variants", :key="v.id")
                            .col-xs
                                variant-override(:variant="v")
                                hr

    template(slot="footer")
        button.btn.btn-fw.green(
            v-if="canManageStationPrices"
            @click="submit",
            :disabled="loading || entry === null"
        )
            v-loading(loader="save-override-pricebook-entry") Save

</template>

<script>
import { mapActions } from 'vuex';
import { getEffectiveVisibility } from './helpers';
import PermissionMixin from './override-permission';
import VariantOverride from './variant_override.vue';

const STORE_KEY = 'override_pricebook';

export default {
    components: { VariantOverride },

    mixins: [PermissionMixin],

    data() {
        return {
            entry: null,
        };
    },

    computed: {
        pricingValidation() {
            if (
                this.entry.max_unit_price !== null &&
                this.entry.max_unit_price !== '0.00'
            ) {
                return `decimal:2|min_value:0|max_value:${
                    this.entry.max_unit_price
                }`;
            }

            return 'decimal:2|min_value:0';
        },

        costValidation() {
            return 'decimal:2|min_value:0';
        },

        restrictPricing() {
            return this.entry.restrict_price_override === 1;
        },

        restrictVisibility() {
            return this.entry.restrict_visibility_override === 1;
        },

        itemIsVisible: {
            get: function() {
                if (this.entry !== null) {
                    return getEffectiveVisibility(this.entry);
                }
            },
            set: function(val) {
                this.entry.entry_hidden = !val;
            },
        },

        loading() {
            return this.onLoading('save-override-pricebook-entry');
        },
    },

    mounted() {
        this.$on('show', e => {
            this.entry = _.cloneDeep(e);
            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        ...mapActions(STORE_KEY, ['saveEntry']),

        setVariantAttribute(index, key, value) {
            this.entry.variants[0][key] = value;
        },

        restrictVariantVisibility(variant) {
            return variant.restrict_visibility_override === 1;
        },

        restrictVariantPricing(variant) {
            return variant.restrict_price_override === 1;
        },

        async submit() {
            if (!(await this.$validator.validate())) return;

            try {
                await this.saveEntry(this.entry);
                this.$emit('entry-saved');
                this.$refs.modal.$emit('hide');
                this.showToastrSuccess();
                //this.entry = null;
            } catch (e) {
                this.showApiError(e);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/edit_override.vue